import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const PlataformaDigitalSection = () => {
  return (
    <section className=" py-10 md:py-24 bg-n-bg-green rounded-3xl">
      <div className="container">
        <div className="grid md:grid-cols-3 grid-cols-1 md:gap-8 items-center">
          <div className="col-span-2">
            <h2 className="mb-5 text-n-beige text-2xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              Somos a primeira plataforma digital de transportes do Brasil.
              Nosso compromisso é elevar o nível de serviço e satisfação quem
              precisa ter um veículo transportado.
            </h2>
            <Link to="/sobre">
              <Button
                variant="ghost"
                className="text-n-secondary hover:text-n-secondary/80 px-0"
                size="lg"
              >
                Conheça a Nacional GO
                <ArrowRight className=" h-6 w-6" />
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center mt-10 md:mt-0">
            <ImageSvg
              src="mobile-outline.svg"
              alt="Primeira plataforma digital de transportes"
              className="w-[80%] h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
